import React, { useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LayoutLogin from '../components/LayoutLogin';
import { MembershipContext } from '../contexts/MembershipContext'; // Asegúrate de que la ruta sea correcta
import { UserContext } from '../contexts/UserContext'; 
import membresias from '../data/membresias.json';

// CSS
import '../assets/css/style.bundle.css';
import '../assets/plugins/global/plugins.bundle.css';
import '../assets/css/styles.custom.css';
import '../assets/css/styles.custom.login.css';

// Importar imágenes
import googleIcon from '../assets/media/svg/brand-logos/google-icon.svg';
import appleBlack from '../assets/media/svg/brand-logos/apple-black.svg';
import appleBlackDark from '../assets/media/svg/brand-logos/apple-black-dark.svg';
import usFlag from '../assets/media/flags/united-states.svg';
import spainFlag from '../assets/media/flags/spain.svg';
import germanyFlag from '../assets/media/flags/germany.svg';
import japanFlag from '../assets/media/flags/japan.svg';
import franceFlag from '../assets/media/flags/france.svg';
//import authBg from '../../assets/media/misc/login_ptp_bg_1.jpg';
import pymesLogo from '../assets/media/logos/logopymes_blanco.png';
//import authScreens from '../assets/media/misc/auth-screens.png';
import imgPtplogo from '../assets/media/logos/nuevo_logo_ptp_web.png';

function LoginPage() {
    const { setSelectedMembership } = useContext(MembershipContext);
	const { setUserData } = useContext(UserContext); // Asegúrate de importar UserContext y useContext de React
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        const email = e.target.email.value;
        const password = e.target.password.value;

        axios.post('https://api.ptpbizintelligence.com/api/web/pymes/auth/login', { email, password })
			.then(response => {
				const { token, name, email, ruc_dni, empresa, group_id, group_name, group_membership, user_id, kiosko_rol_id, universidad, terminos } = response.data;
				localStorage.setItem('jwtToken', token);
				console.log('miToken login:',token);
				// Guardar los datos adicionales del usuario
				localStorage.setItem('userInfo', JSON.stringify({ name, email, ruc_dni, empresa, group_id, group_name, group_membership, user_id, kiosko_rol_id, universidad, terminos }));

				// Actualiza UserContext con los nuevos datos del usuario
				setUserData({ name, email, ruc_dni, empresa, group_id, group_name, group_membership, user_id, kiosko_rol_id, universidad, terminos }); // Actualiza el estado del contexto
			
				if (token) {
					let adjustedMembership = group_membership;
					console.log('login return PYMES:',response.data);
			
					// Ajustar la membresía para los roles especiales
					if (group_membership === "Administrator" || group_membership === "Pymes Ventas") {
						adjustedMembership = "Pymes VIP"; // Ajuste según la lógica de negocio
					}
			
					// Buscar el alias de la membresía ajustada
					const membershipInfo = membresias.membresias.find(m => m.nombre === adjustedMembership);
					const selectedAlias = membershipInfo ? membershipInfo.alias : null;
			
					if (selectedAlias) {
						setSelectedMembership(adjustedMembership); // Actualizar el contexto con la membresía ajustada
					}
			
					navigate('/dashboard');
				}
			})
            .catch(error => {
                console.error("Error durante el inicio de sesión: ", error);
                alert('Error durante el inicio de sesión');
            });
    };

	 
  return (
	<LayoutLogin>
		<Helmet>
			<title>Top Pymes login</title>
		</Helmet>
		<div className="d-flex flex-column flex-root loginRoot">
			{/* begin::Page bg image */} 
			
			{/* end::Page bg image */} 
			{/* begin::Authentication - Sign-in  */} 
			<div className="d-flex flex-column flex-column-fluid flex-lg-row loginRootL2">
				{/* begin::Aside */} 
				<div className="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
					{/* begin::Aside */} 
					<div className="d-flex flex-center flex-lg-start flex-column">
						{/* begin::Logo */} 
						<img alt="Logo" className='loginLogoProduct' src={pymesLogo} />
						{/* end::Logo */} 
						{/* begin::Title */} 
						<h2 className="text-white  fw-normal m-0 loginSubtitle">El primer y único directorio de empresas en el Perú enfocado en el segmento de Pequeña empresa.</h2>
						{/* end::Title */} 
					</div>
					{/* begin::Aside */} 
				</div>
				{/* begin::Aside */} 
				{/* begin::Body */} 
				<div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12 p-lg-20">
					{/* begin::Card */} 
					<div className="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-600px p-20">
						{/* begin::Wrapper */} 
						<div className="d-flex flex-center flex-column flex-column-fluid px-lg-10 pb-15 pb-lg-20">
							{/* begin::Form */} 
							<form className="form w-100" novalidate="novalidate" id="kt_sign_in_form" action="#" onSubmit={handleLogin}>
								{/* begin::Heading */} 
								<div className="text-center mb-11">
									<img src={imgPtplogo} className="loginLogo" />
									{/* begin::Title */} 
									<h1 className="text-gray-900 fw-bolder mb-3">Top Pymes Online</h1>
									{/* end::Title */} 
									
								</div>
								{/* begin::Heading */} 

								
								{/* begin::Input group= */} 
								<div className="fv-row mb-8">
									{/* begin::Email */} 
									<input type="text" placeholder="Email" name="email" autocomplete="off" className="form-control bg-transparent" />
									{/* end::Email */} 
								</div>
								{/* end::Input group= */} 
								<div className="fv-row mb-3">
									{/* begin::Password */} 
									<input type="password" placeholder="Password" name="password" autocomplete="off" className="form-control bg-transparent" />
									{/* end::Password */} 
								</div>
								{/* end::Input group= */} 
								{/* begin::Wrapper */} 
								<div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
									<div></div>
									{/* begin::Link 
									<a href="authentication/layouts/creative/reset-password.html" className="link-primary">¿Olvidaste tu contraseña?</a>
									 end::Link */} 
								</div>
								{/* end::Wrapper */} 
								{/* begin::Submit button */} 
								<div className="d-grid mb-10">
									<button type="submit" id="kt_sign_in_submit" className="btn btn-primary">
										{/* begin::Indicator label */} 
										<span className="indicator-label">Ingresar</span>
										{/* end::Indicator label */} 
										{/* begin::Indicator progress */} 
										<span className="indicator-progress">Please wait... 
										<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
										{/* end::Indicator progress */} 
									</button>
								</div>
								{/* end::Submit button */} 
								{/* begin::Sign up */} 
								{/*
								<div className="text-gray-500 text-center fw-semibold fs-6">¿Aún no tienes una cuenta? <br />
								<a href="authentication/layouts/creative/sign-up.html" className="link-primary">Crea tu demo</a></div>
								*/}
								{/* end::Sign up */} 
							</form>
							{/* end::Form */} 
						</div>
						{/* end::Wrapper */} 
						{/* begin::Footer */} 
						<div className="d-flex flex-stack px-lg-10">
							
						</div>
						{/* end::Footer */} 
					</div>
					{/* end::Card */} 
				</div>
				{/* end::Body */} 
			</div>
			{/* end::Authentication - Sign-in */} 
		</div>
	</LayoutLogin>
  );
}

export default LoginPage;
